// removed by extract-text-webpack-plugin
module.exports = {"smallCard":"HxbGtFYr4W72JpYkjWo_c","box":"_2OBrsIP9yVsGdAyUTmsAnp","contentBox":"_21nGXCnMMrDr7w5CQrFluy","left":"_21rSTreUBlJxoI5ETuj0cu","right":"_3thwroF_NvxqBbKJuxyFVM","category":"_2NNMksGVNl6yml_5TQdynO","name":"_1CiQQxESpzKV9vk9oxS-Gl","address":"_1OEyrZ6RAdRcQb4fCITDJA","icon":"_2pr16MDrxDbHyICevPFoDU","text":"_1hXsORnXUuVR3tNSDYm_Zm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/SmallCard.scss
// module id = 453
// module chunks = 0